import {
  FEATURE_FLAGS,
  useOrganizationFeatureFlagScope,
  usePostHydrationFeatureFlagValue,
} from "@/feature-flags"

import type { MetricRecordData } from "@/types/metrics/contracts"

const SUPPORTED_MANAGERS = new Set([
  "manager_llm_binary",
  "manager_default_categorical",
  "manager_numerical_llm_judge",
])

export function CovalJudgeConfidenceInfo({
  metricRecordData,
}: {
  metricRecordData: MetricRecordData
}) {
  const flag = usePostHydrationFeatureFlagValue(
    FEATURE_FLAGS.LLM_JUDGE_JEV_CALIBRATION,
  )
  const { isReady } = useOrganizationFeatureFlagScope()

  if (
    !isReady ||
    flag !== true ||
    !SUPPORTED_MANAGERS.has(metricRecordData.metric_manager) ||
    metricRecordData.metric_metadata.use_knowledge_base === true ||
    metricRecordData.metric_metadata.model_version !== "coval_judge"
  ) {
    return null
  }

  return (
    <p className="text-sm text-coval-text-muted">
      Coval&apos;s Judge includes panel agreement and, when available, estimated
      probabilities for each answer. Results flag disagreement for review.
    </p>
  )
}
